module.exports = __webpack_public_path__ + "static/media/webdesign-services-img31.c18f1a17.jpg";